import { selectCountries } from "../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { Url } from "../../../../router/enums";
import { selectCountry } from "../../../../store/HOC/genericUI.selectors";
import { peselMask, postalCodeMask } from "../../../../utilities/masks";
import {
  selectApplicantAvailableCities,
  selectApplicantDriverData,
  selectShouldNotValidateByPesel,
  selectUIData,
} from "../applicant.selectors";
import {
  setAvailableCities,
  setLackOfPesel,
  setUIField,
  setUIObjectField,
} from "../applicant.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.APPLICANT_DRIVER,
  selector: selectApplicantDriverData,
  redirect: Url.AC_INCIDENT,
  content: [
    {
      title: "Dane kierowcy",
      sections: [
        {
          id: "applicant-driver-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_DRIVER_NAME,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_DRIVER_SURNAME,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: "applicant-driver-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("driverphone"),
              id: ComponentId.APPLICANT_DRIVER_PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_DRIVER_EMAIL,
              label: "Email",
              required: true,
            },
          ],
        },
        {
          id: "applicant-driver-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              mask: peselMask,
              id: ComponentId.APPLICANT_DRIVER_PESEL,
              disabled: selectShouldNotValidateByPesel,
              label: "PESEL",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_DRIVER_DRIVING_LICENSE,
              label: "Numer prawa jazdy",
              required: selectShouldNotValidateByPesel,
            },
          ],
        },
        {
          id: "applicant-driver-data-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.CHECKBOX,
              id: ComponentId.APPLICANT_DRIVER_LACK_OF_PESEL,
              label: "",
              onChange: setLackOfPesel,
              items: [
                {
                  label: "Brak numeru PESEL",
                  value: "true",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: "Miejsce zamieszkania",
      sections: [
        {
          id: "applicant-driver-data-5",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_DRIVER_STREET,
              label: "Ulica",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.APPLICANT_DRIVER_STREET_2,
              label: "Numer budynku / mieszkania",
              required: true,
            },
          ],
        },
        {
          id: "applicant-driver-data-6",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.APPLICANT_DRIVER_ZIP_CODE,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
              required: true,
            },
            {
              type: FormElement.SELECT_CITY,
              id: ComponentId.APPLICANT_DRIVER_CITY,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectApplicantAvailableCities,
              required: true,
            },
          ],
        },
        {
          id: "applicant-driver-data-7",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.APPLICANT_DRIVER_COUNTRY,
              onChange: setUIField,
              items: selectCountries,
              required: true,
              label: "Kraj",
            },
          ],
        },
      ],
    },
  ],
};
